export const AiSdkIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path fill="currentColor" d="M8.002 1.333 14.668 14H1.335z" />
    </svg>
  );
};
